<template>
  <div class="marketInfo">
    <market-info
      :linkInfo="linkInfo"
      @backTop="linkInfo = undefined"
      v-if="linkInfo"
    />
    <div v-else class="content">
      <div class="jumpPage">
        <span class="jumpPage-btn" @click="backTop"
          ><i class="el-icon-back"></i>返回</span
        >
      </div>
      <el-divider></el-divider>
      <p @click="" class="content_title">
        数据来源:<a class="content_title_a" href="https://www.cneeex.com/" target="_blank"
          >上海环境能源交易所</a
        >
      </p>
      <el-divider></el-divider>
      <div v-if="marketList[0].contents.length" class="content_link">
        <el-row>
          <el-col
            v-for="item in carbonList.list"
            v-if="item.linkUrl || item.linkParams.articleId"
            :span="12"
          >
            <span
              v-if="item.linkParams.articleId"
              class="content_link_name"
              @click="linkInfo = item"
              >{{ item.title }}</span
            >
            <a
              v-else
              class="content_link_name"
              target="_blank"
              :href="item.linkUrl"
              >{{ item.title }}</a
            >
          </el-col>
        </el-row>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="form.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="form.total"
          >
          </el-pagination>
        </div>
      </div>
      <el-empty v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: 'carbonMarket',
  components: {
    marketInfo: () => import('./marketInfo.vue'),
  },
  props: {
    marketList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    marketList: {
      deep: true,
      immediate: true,
      handler: function (newValue) {
        if (newValue[0].contents && newValue[0].contents.length) {
          this.getTablelist(newValue);
        }
      },
    },
  },
  data() {
    return {
      linkInfo: undefined,
      carbonList: {},
      form: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    backTop() {
      this.$emit('backHome');
    },
    getTablelist(list) {
      if (list[0].contents && list[0].contents.length) {
        this.carbonList = this.paginateArray(list[0].contents, this.form);
        console.log(this.carbonList, 'xxxxxxxxxxxx');
      }
    },
    /**
     * 对数组进行分页处理
     * @param {Array} array - 需要分页的数组
     * @param {Object} form - 分页参数对象
     * @param {number} form.pageNum - 当前页码（从1开始）
     * @param {number} form.pageSize - 每页显示条数
     * @returns {Object} 分页结果，包含当前页数据和总页数
     */
    paginateArray(array, form) {
      // 参数校验
      if (!Array.isArray(array)) {
        throw new Error('第一个参数必须是数组');
      }
      if (typeof form !== 'object' || form === null) {
        throw new Error('第二个参数必须是包含pageNum和pageSize的对象');
      }

      // 处理页码和每页条数，确保为有效数字
      const pageNum = Math.max(1, parseInt(form.pageNum, 10) || 1);
      const pageSize = Math.max(1, parseInt(form.pageSize, 10) || 10);

      // 计算总条数和总页数
      const total = array.length;
      const totalPages = Math.ceil(total / pageSize);

      // 计算起始索引（处理页码超出范围的情况）
      const safePageNum = Math.min(pageNum, totalPages || 1);
      const startIndex = (safePageNum - 1) * pageSize;

      // 截取当前页数据
      const currentPageData = array.slice(startIndex, startIndex + pageSize);
      // 赋值数据长度
      this.form.total = total;
      return {
        list: currentPageData, // 当前页数据
        total: total, // 总条数
        totalPages: totalPages, // 总页数
        currentPage: safePageNum, // 当前页码（处理后）
        pageSize: pageSize, // 每页条数
      };
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.pageSize = val;
      this.getTablelist(this.marketList);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.pageNum = val;
      this.getTablelist(this.marketList);
    },
  },
};
</script>

<style lang="less" scoped>
.marketInfo {
  width: 1400px;
  margin: auto;
}
.jumpPage {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: start;
  .jumpPage-btn {
    font-size: 16px;
    cursor: pointer;
    color: #409eff;
  }
}
.content {
  width: inherit;
  .content_title {
    font-size: 20px;
    font-weight: 500;
    color: rgba(26, 190, 107, 1);
  }
  .content_title_a:hover {
    color: #409eff;
  }
}
.content_link {
  width: inherit;
  .content_link_name {
    font-size: 20px;
    padding: 5px 0;
    cursor: pointer;
  }
  .content_link_name:hover {
    color: #409eff;
  }
}
.pagination {
  margin-top: 15px;
  text-align: right;
}


@media screen and (max-width: 768px) {
  .marketInfo {
    margin: 8px 0 20px;
    width: 100%;
    .jumpPage {
      margin: 10px 0 0 0;
      .jumpPage-btn {
        font-size: 12px;
      }
    }

    .content_title {
      font-size: 12px;
    }

    .content_link {
      .el-col {
        width: 100%;
      }
      .content_link_name {
        font-size: 12px;
      }

      .pagination {
        margin-top: 20px;

        /deep/.el-pagination {
          display: flex;
          justify-content: center;
          .el-pagination__sizes, .el-pagination__jump {
            display: none;
          }
        }

        
      }
    }

    .el-divider {
      margin: 10px 0;
    }
  }
}

</style>
